const BlankLayout = ({ children }) => <div>{children}</div>;
export default BlankLayout;
